import { render, staticRenderFns } from "./RejectedAssignment.vue?vue&type=template&id=200bb555&scoped=true&"
import script from "./RejectedAssignment.vue?vue&type=script&lang=js&"
export * from "./RejectedAssignment.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/buyer-job-text.css?vue&type=style&index=0&id=200bb555&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bb555",
  null
  
)

export default component.exports